import { QUEUE_COUNT } from '../../constants.js';

const initialCount = {
  count : 0,
  countType : -1,
  time: 0
};

const queueCount = (state = initialCount, action) => {
  switch (action.type) {
    case QUEUE_COUNT.CALLS:
      return { countType : action.type, count : action.count, time : action.time };
    case QUEUE_COUNT.MESSAGES:
    case QUEUE_COUNT.FACEBOOK:
    case QUEUE_COUNT.LINKEDIN:
    case QUEUE_COUNT.TWITTER:
    case QUEUE_COUNT.MAIL:
      return { countType : action.type, count : action.count, time : action.time };
    default:
      return state;
  }
}

export default queueCount;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_queue_count.js